import { HATCH_EGG_PAGE, HATCH_EGG_PLAY_STATE } from '../actions/hatch-egg';
import {
  GOTO_COLLECTION_PAGE,
  SET_BIRD_NUMBER,
  PLAY_STAGE_NUMBER,
  BACKTO_MAIN_PAGE,
  UPDATE_PLAY_DATA,
  SET_BIRD_ENERGY,
  BIRD_ENERGY_UPDATE_FLAG,
  // DISPLAY_STONES,
  // SET_PLAY_STATE,
} from '../actions/types';

const initialState = {
  // page: HATCH_EGG_PAGE.PLAY,
  page: null,
  birdNumber: null,
  stageNumber: 1,
  stones: [],
  hatchCount: null,
  breakCount: null,
  duplicated: false,
  birdEnergy: 1,
  birdEnergyUpdateFlag: false,
  // playState: HATCH_EGG_PLAY_STATE.IDLE,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GOTO_COLLECTION_PAGE:
      return { ...state, page: HATCH_EGG_PAGE.COLLOECTION };
    case SET_BIRD_NUMBER:
      console.debug('Reducer SET_BIRD_NUMBER payload:', payload);
      return {
        ...state,
        birdNumber: payload.birdNumber,
        duplicated: payload.duplicated,
      };
    case PLAY_STAGE_NUMBER:
      return {
        ...state,
        page: HATCH_EGG_PAGE.PLAY,
        stageNumber: payload.stageNumber,
        playId: payload.playId,
      };
    case BACKTO_MAIN_PAGE:
      return { ...state, page: HATCH_EGG_PAGE.MAIN };
    case UPDATE_PLAY_DATA:
      const { breakCount, hatchCount } = payload;
      return { ...state, breakCount: breakCount, hatchCount: hatchCount };
    case SET_BIRD_ENERGY:
      const birdEnergy = payload;
      return { ...state, birdEnergy: birdEnergy };

    case BIRD_ENERGY_UPDATE_FLAG:
      const flag = payload;
      return { ...state, birdEnergyUpdateFlag: flag };
    // case DISPLAY_STONES:
    //   return { ...state, stones: payload.stones };
    // case SET_PLAY_STATE:
    //   return { ...state, playState: payload.playState };
    default:
      return state;
  }
}
